module.exports = __webpack_public_path__ + "img/rectangle@2x.b1e4cda6.png";